/**
 * Maps Clamp QC hub inspection answers to `quality.clamp` columns the hub will own when persistence is wired.
 * Physical fail reasons are persisted as rows in `quality.clamp_mechanical_failure_reason` pointing at
 * `quality.failure_reason` (test id 1); inductance and line harvest outcomes use separate columns on `quality.clamp`.
 */

/** Sorted copy for stable JSON and text join (matches hub inspection row `failReason` ordering). */
export function sortedPhysicalFailReasons(reasons: readonly string[]): string[] {
  return [...reasons].sort((left, right) => left.localeCompare(right, undefined, { sensitivity: "base" }));
}

/**
 * `sgs_mechanical_pass` is true when no physical inspection fail reasons are selected (checkbox list only).
 */
export function mechanicalPassFromPhysicalFailReasons(physicalFailReasons: readonly string[]): boolean {
  return physicalFailReasons.length === 0;
}

/**
 * Denormalized text for reporting and legacy readers; null when no physical fails.
 */
export function mechanicalFailReasonText(physicalFailReasons: readonly string[]): string | null {
  const sorted = sortedPhysicalFailReasons(physicalFailReasons);
  if (sorted.length === 0) {
    return null;
  }
  return sorted.join("; ");
}

/**
 * Hub rule: line harvest performed is always true on persist today; any row that records an inductance pass
 * also satisfies that (inductance pass is a subset of all persisted rows).
 */
export function lineHarvestPerformedForHubPersist(): boolean {
  return true;
}

export type LineHarvestTesterAndDragInput = {
  /** Stored on inspection rows as `testerA`: gray band → line tester path with pass or fail recorded. */
  testerConnectedFromGrayBandWorkflow: boolean;
  /** Drag delta (unloaded minus loaded before tester); null when unknown. */
  dragDelta: number | null;
};

export function lineHarvestTesterFromHubInput(input: LineHarvestTesterAndDragInput): boolean {
  return input.testerConnectedFromGrayBandWorkflow;
}

export function lineHarvestDragFromHubInput(input: LineHarvestTesterAndDragInput): number | null {
  return input.dragDelta;
}
